<template>
  <div class="p-2">
    <div class="row">
      <div class="col-6 col-md-6 pl-0">
        <div class="form-group">
          <label> Symbol </label>
          <select class="form-control" v-model="symbol">
            <option v-for="symbol in symbols" :value="symbol.name">
              {{ symbol.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="col-6 col-md-6">
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label>Is lotin in percentage.</label>
              <b-form-checkbox
                v-model="loting_percentage"
                name="loting_percentage"
                value="1"
                unchecked-value="0"
              >
                <span v-if="parseInt(loting_percentage)">
                  Yes, send loting in percentage.
                </span>
                <span v-else> Not, Do not send loting in percentage. </span>
              </b-form-checkbox>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label>
                Loting
                <span
                  class="small text-muted"
                  v-if="parseInt(loting_percentage)"
                  >(%)</span
                >
              </label>
              <input
                type="text"
                max="100"
                min="0"
                step="1"
                class="form-control"
                v-model="loting"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6 col-md-6 pl-0">
        <div class="form-group">
          <label> Type </label>
          <select class="form-control" v-model="type">
            <option value="buy">Buy</option>
            <option value="sell">Sell</option>
          </select>
        </div>
      </div>

      <div class="col-6 col-md-6">
        <div class="form-group">
          <label>Laverage</label>
          <input
            type="text"
            class="form-control"
            value="1"
            v-model.number="laverage"
          />
        </div>
      </div>

      <div class="col-6 col-md-6 pr-1" v-if="false">
        <div class="form-group">
          <label> Commission </label>
          <input
            type="text"
            max="100"
            min="0"
            step="1"
            class="form-control"
            v-model.number="commission"
          />
        </div>
      </div>

      <div class="col-6 col-md-6 pl-1">
        <div class="form-group">
          <label> Stop Loss </label>
          <input type="text" class="form-control" v-model="stop_loss" />
        </div>
      </div>

      <div class="col-6 col-md-6 pr-1">
        <div class="form-group">
          <label> Take Profit </label>
          <input type="text" class="form-control" v-model="take_profit" />
        </div>
      </div>

      <div class="col-6 col-md-6 pl-1">
        <div class="form-group">
          <label> Trailing-Activation </label>
          <input
            type="text"
            class="form-control"
            v-model="trailing_activation"
          />
        </div>
      </div>

      <div class="col-6 col-md-6 pr-1">
        <div class="form-group">
          <label> Trailing-Step </label>
          <input type="text" class="form-control" v-model="trailing_step" />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <!--<b-button @click="showModalOrderGenerate" class="mr-2">
          <b-icon icon="gear"></b-icon> Configuration
        </b-button>-->
        <b-button class="ml-2" @click="sendOrder" v-if="!send_order">
          <b-icon-check></b-icon-check> Send
        </b-button>
        <b-button class="ml-2" @click="sendOrder" v-if="send_order">
          <b-icon icon="arrow-repeat" animation="spin-pulse"></b-icon> Send
          <b-icon-check></b-icon-check>
        </b-button>
      </div>
    </div>

    <!--<b-modal id="modal-order-generate" hide-footer hide-header size="xl" ok-only>
      <div class="modal-create-conditions">
        <h3 class="modal-title d-flex justify-content-between"><span>Orders Generator</span></h3>
        <OrdersConfigurationGenerator
          ref="conditionGeneratorBuy"
          :showSignal="false"
          @handleAddModify="handleAddModify"
        />
      </div>
    </b-modal>-->
  </div>
</template>

<script>
// import OrdersConfigurationGenerator from './investors-orders-form/OrdersConfigurationGenerator';

export default {
  name: "InvestorOrdersForm",
  /* components: {
    OrdersConfigurationGenerator,
  }, */
  created() {
    this.getSymbols();
  },
  props: {
    return_form: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      config: false,
      condition: {},
      error: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" rx="10" fill="#DC3545" fill-opacity="0.3"/>
      <path d="M12.4999 7.49992C12.4218 7.42181 12.3158 7.37793 12.2053 7.37793C12.0949 7.37793 11.9889 7.42181 11.9108 7.49992L9.99992 9.41076L8.08909 7.49992C8.01095 7.42181 7.90499 7.37793 7.79451 7.37793C7.68402 7.37793 7.57806 7.42181 7.49992 7.49992C7.42181 7.57806 7.37793 7.68402 7.37793 7.79451C7.37793 7.90499 7.42181 8.01095 7.49992 8.08909L9.41076 9.99992L7.49992 11.9108C7.42181 11.9889 7.37793 12.0949 7.37793 12.2053C7.37793 12.3158 7.42181 12.4218 7.49992 12.4999C7.57806 12.578 7.68402 12.6219 7.79451 12.6219C7.90499 12.6219 8.01095 12.578 8.08909 12.4999L9.99992 10.5891L11.9108 12.4999C11.9889 12.578 12.0949 12.6219 12.2053 12.6219C12.3158 12.6219 12.4218 12.578 12.4999 12.4999C12.578 12.4218 12.6219 12.3158 12.6219 12.2053C12.6219 12.0949 12.578 11.9889 12.4999 11.9108L10.5891 9.99992L12.4999 8.08909C12.578 8.01095 12.6219 7.90499 12.6219 7.79451C12.6219 7.68402 12.578 7.57806 12.4999 7.49992Z" fill="#1D1E25"/>
      </svg> Error`,
      loting: 1,
      type: "buy",
      dependent: 0,
      laverage: 1,
      symbol: "BTCUSDT",
      symbols: [],
      commission: 0.04,
      stop_loss: 0,
      take_profit: 0,
      trailing_activation: 0,
      trailing_step: 0,
      send_order: 0,
      loting_percentage: 1,
      success: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="20" height="20" rx="10" fill="#8BF125" fill-opacity="0.3"/>
          <g clip-path="url(#clip0_1634_940)">
          <path d="M14.2995 6.84625L8.5416 12.6038C8.50288 12.6426 8.45688 12.6735 8.40622 12.6945C8.35556 12.7155 8.30124 12.7264 8.24639 12.7264C8.19153 12.7264 8.13722 12.7155 8.08656 12.6945C8.0359 12.6735 7.98989 12.6426 7.95118 12.6038L5.72451 10.375C5.6858 10.3361 5.63979 10.3053 5.58913 10.2843C5.53848 10.2632 5.48416 10.2524 5.4293 10.2524C5.37445 10.2524 5.32013 10.2632 5.26947 10.2843C5.21881 10.3053 5.17281 10.3361 5.1341 10.375C5.09523 10.4137 5.06439 10.4597 5.04335 10.5104C5.02231 10.561 5.01147 10.6154 5.01147 10.6702C5.01147 10.7251 5.02231 10.7794 5.04335 10.83C5.06439 10.8807 5.09523 10.9267 5.1341 10.9654L7.3616 13.1925C7.59657 13.427 7.91501 13.5588 8.24701 13.5588C8.57901 13.5588 8.89745 13.427 9.13243 13.1925L14.8899 7.43625C14.9287 7.39755 14.9595 7.35157 14.9805 7.30095C15.0015 7.25033 15.0123 7.19606 15.0123 7.14125C15.0123 7.08645 15.0015 7.03218 14.9805 6.98156C14.9595 6.93094 14.9287 6.88496 14.8899 6.84625C14.8512 6.80739 14.8052 6.77655 14.7546 6.75551C14.7039 6.73446 14.6496 6.72363 14.5947 6.72363C14.5399 6.72363 14.4855 6.73446 14.4349 6.75551C14.3842 6.77655 14.3382 6.80739 14.2995 6.84625Z" fill="#1D1E25"/>
          </g>
          <defs>
          <clipPath id="clip0_1634_940">
          <rect width="10" height="10" fill="white" transform="translate(5 5)"/>
          </clipPath>
          </defs>
          </svg> Success`,
    };
  },
  methods: {
    showModalOrderGenerate() {
      this.$bvModal.show("modal-order-generate");
    },
    getSymbols() {
      this.$http
        .server1("bwfs/get/symbols/binance", {})
        .then((res) => {
          if (res.error) {
            return;
          }
          this.symbols = res.data;
        })
        .catch(() => {});
    },
    handleAddModify(condition) {
      this.condition = condition;
      this.$bvModal.hide("modal-order-generate");
      this.config = true;
    },
    sendOrder() {
      if (Number(this.laverage) < 1) {
        this.$toastr.error(
          "The minimum value of laverage is 1",
          `${this.error}`
        );
        return;
      }

      if (this.take_profit < 0) {
        this.$toastr.error(
          "Take profit only allows positive values",
          `${this.error}`
        );
        return false;
      }

      if (this.stop_loss < 1 || this.stop_loss > 100) {
        this.$toastr.error(
          "Stop Loss only allows positive values ​​and less than 100.",
          `${this.error}`
        );
        return false;
      }

      if (this.trailing_activation < 0) {
        this.$toastr.error(
          "Trailing activation only allows positive values",
          `${this.error}`
        );
        return false;
      }

      if (this.trailing_step < 0) {
        this.$toastr.error(
          "Trailing step only allows positive values",
          `${this.error}`
        );
        return false;
      }

      let loting_percentage = parseInt(this.loting_percentage);
      let loting = this.loting;
      if (loting_percentage) {
        if (parseFloat(loting) > 100 || parseFloat(loting) < 1) {
          this.$toastr.error(
            "The loting field max value is 100 and min value 1",
            `${this.error}`
          );
          return;
        }
        loting = loting / 100;
      }

      const data = {
        symbol: this.symbol.toLowerCase(),
        commission: this.commission,
        loting: loting,
        loting_percentage: loting_percentage,
        laverage: this.laverage,
        side: this.type.toLowerCase(),
        dependent: this.dependent ? 1 : 0,
        price_mode: 0,
        open_conditions: JSON.stringify({
          max_time_to_wait: 0,
        }),
        close_conditions: JSON.stringify({
          stop_loss:
            parseFloat(this.stop_loss) > 0
              ? parseFloat(this.stop_loss) / 100
              : 0,
          take_profit:
            parseFloat(this.take_profit) > 0
              ? parseFloat(this.take_profit) / 100
              : 0,
          trailing_activation:
            parseFloat(this.trailing_activation) > 0
              ? parseFloat(this.trailing_activation) / 100
              : 0,
          trailing_step:
            parseFloat(this.trailing_step) > 0
              ? parseFloat(this.trailing_step) / 100
              : 0,
        }),
      };
      if (this.condition) {
        data["close_conditions_dynamics"] = JSON.stringify(
          this.condition.close_condition_dynamic
        );
      }
      if (this.$props.return_form) {
        this.$emit("sendOrder", data);
        return;
      } else {
        data["investor_token"] = this.$store.state.info_investor.info.token;
      }

      this.send_order = 1;
      this.$http
        .server1("bwfs/admin/InvestorExpertPanel/create_an_order_2", data)
        .then((res) => {
          if (res.error) {
            this.send_order = 0;
            this.$toastr.error(`${res.msg}`, `${this.error}`);
            return;
          }
          this.send_order = 0;
          this.$toastr.success("Success send order", `${this.success}`);
        })
        .catch((e) => {
          this.send_order = 0;
          this.$toastr.error(`${e.message}`, `${this.error}`);
        });
    },
  },
  watch: {
    take_profit(value) {
      if (isNaN(Number(value))) {
        this.take_profit = 0;
      }
    },
    stop_loss(value) {
      if (isNaN(Number(value))) {
        this.stop_loss = 0;
      }
    },
    trailing_activation(value) {
      if (isNaN(Number(value))) {
        this.trailing_activation = 0;
      }
    },
    trailing_step(value) {
      if (isNaN(Number(value))) {
        this.trailing_step = 0;
      }
    },
  },
};
</script>

<style scoped>
.list-group-item {
  border: 0;
}
</style>
